import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteAllAcademicYears as apiDeleteAll } from "../../api/apiAcademicYears";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useDeleteAllAcademicYears() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: deleteAllAcademicYears, isPending: isDelete } = useMutation({
        mutationFn: (req) => apiDeleteAll(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["academicYears"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { deleteAllAcademicYears, isDelete };
}
